import SelectContianer from '../components/twStore/SelectContianer';
export default {
  components: { SelectContianer },
  props: ['showChildSelector'],
  data() {
    return {
      showChildSelect: false,
    };
  },
  computed: {
    languages() {
      return this.$store.state.store.languages;
    },
  },
  watch: {
    showChildSelector(newVal) {
      this.showChildSelect = newVal;
    },
  },
  methods: {
    close() {
      this.$emit('closeSelecter');
    },
  },
};
